/*
 * @Author: your name
 * @Date: 2021-04-02 14:25:02
 * @LastEditTime: 2021-04-02 14:25:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \test\src\components\res\SunNewComponents\NewTree\TreeBus.js
 */
import Vue from 'vue'
export const TreeBus = new Vue()